// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Isaias (Isaiah)",
  bookSlug: "isaias",
  chapter: 4,
  argument: "After an extremity of evils that shall fall upon the Jews, a remnant shall be comforted by Christ.",
  verses: [
    { n: 1, text: "And in that day seven women shall take hold of one man, saying: We will eat our own bread, and wear our own apparel: only let us be called by thy name, take away our reproach." },
    { n: 2, text: "In that day the bud of the Lord shall be in magnificence and glory, and the fruit of the earth shall be high, and a great joy to them that shall have escaped of Israel." },
    { n: 3, text: "And it shall come to pass, that every one that shall be left in Sion, and that shall remain in Jerusalem, shall be called holy, every one that is written in life in Jerusalem." },
    { n: 4, text: "If the Lord shall wash away the filth of the daughters of Sion, and shall wash away the blood of Jerusalem out of the midst thereof, by the spirit of judgment, and by the spirit of burning." },
    { n: 5, text: "And the Lord will create upon every place of Mount Sion, and where he is called upon, a cloud by day, and a smoke, and the brightness of a flaming fire in the night: for over all the glory shall be a protection." },
    { n: 6, text: "And there shall be a tabernacle for a shade in the day-time from the heat, and for a security and covert from the whirlwind, and from rain." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Seven. Many shall sue for a husband, men shall be so scarce. To continue unmarried was reproachful, Deuteronomy vii. 14. (Calmet) — After the conversion of the Gentiles, pastors will be much wanted.", attribution: "Worthington" }
    ] },
    { verse: 2, notes: [
      { text: "Bud. That is, Christ, (Challoner) who was faintly prefigured by Zorobabel, Zacharias iii. 8. Our Saviour was the fruit of the earth, and sovereign Lord.", attribution: "Calmet" }
    ] },
    { verse: 3, notes: [
      { text: "Life. Only the faithful shall be saved. (Worthington) — The Jews, after the captivity, shall be more obedient. But converts to the faith of Christ are styled saints, (Romans i. 7., &c.) such particularly as are predestined to glory, Romans viii. 30. (Calmet) — Those who are called to life and the true faith, may forfeit this honour, by their own fault.", attribution: "Menochius" }
    ] },
    { verse: 4, notes: [
      { text: "Burning. By baptism of water and fire, or of the Holy Ghost.", attribution: "St. Jerome" }
    ] },
    { verse: 5, notes: [
      { text: "Protection. God will protect his Church, more than he did the Israelites by the pillar, Exodus xiv. 20.", attribution: "St. Basil, &c." }
    ] },
  ],
};

export default chapter;
